import React from "react";

const PrivacyHeader = () => {
  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold mb-8 text-foreground">Privacy Policy</h1>
      <p className="text-muted-foreground dark:text-gray-300 mb-6">Last updated: March 2, 2026</p>
    </div>
  );
};

export default PrivacyHeader;